webpackJsonp([192864653623833],{

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/left-bg.a6359724.svg";

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/right-bg.48ca1da9.svg";

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.formBottomStyle = exports.checkboxWrapStyle = exports.titleStyle = exports.introParagraphStyle = exports.innerWrapperStyle = exports.wrapperStyle = undefined;
	
	var _css, _css2, _css3;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _leftBg = __webpack_require__(364);
	
	var _leftBg2 = _interopRequireDefault(_leftBg);
	
	var _rightBg = __webpack_require__(365);
	
	var _rightBg2 = _interopRequireDefault(_rightBg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)((_css = {}, _css['@media (min-width: ' + (_globalStyles.mobileMaxWidthBreakpoint + 1) + 'px)'] = {
		backgroundImage: 'url(' + _leftBg2.default + '), url(' + _rightBg2.default + ')',
		backgroundPosition: 'top left, bottom right',
		backgroundRepeat: 'no-repeat',
		minHeight: '652px',
		padding: '100px 0 0 0'
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		padding: '15px 0'
	}, _css));
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)((_css2 = {
		maxWidth: '500px',
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px'
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		padding: '0 10px'
	}, _css2));
	
	var introParagraphStyle = exports.introParagraphStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)((_css3 = {
		marginBottom: '60px'
	}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		marginBottom: '30px'
	}, _css3)));
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingXLarge, /*#__PURE__*/(0, _emotion.css)({}));
	
	var checkboxWrapStyle = /*#__PURE__*/exports.checkboxWrapStyle = (0, _emotion.css)({
		color: _globalStyles.grey,
		fontSize: '12px',
		lineHeight: '15px',
		marginBottom: '45px',
		'& input': {
			verticalAlign: 'middle'
		},
		'& span': {
			display: 'inline-block',
			marginLeft: '10px',
			verticalAlign: 'bottom'
		}
	});
	
	var formBottomStyle = /*#__PURE__*/exports.formBottomStyle = (0, _emotion.css)({
		'& div:first-child': {
			float: 'left'
		},
		'& div:last-child': {
			float: 'right',
			'& a': {
				textDecoration: 'none',
				color: _globalStyles.grey,
				fontSize: '12px',
				lineHeight: '15px'
			}
		},
		'&:after': {
			clear: 'both',
			display: 'block',
			content: '" "'
		}
	});

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactPasswordMask = __webpack_require__(426);
	
	var _reactPasswordMask2 = _interopRequireDefault(_reactPasswordMask);
	
	var _qs = __webpack_require__(77);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _pragmaticForms = __webpack_require__(60);
	
	var _link = __webpack_require__(9);
	
	var _authManager = __webpack_require__(35);
	
	var _headerManager = __webpack_require__(31);
	
	var _logIn = __webpack_require__(263);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var LoginForm = (0, _pragmaticForms.configureForm)({
		initFields: function initFields(_ref) {
			var redirect = _ref.redirect;
			return {
				email: '',
				password: '',
				rememberMe: false,
				redirect: redirect
			};
		},
		validate: function validate(_ref2) {
			var email = _ref2.email,
			    password = _ref2.password;
	
			var errors = {};
			if (!email) errors.email = 'Please enter an Email Address';
			if (!password) errors.password = 'Please enter a password';
			return errors;
		},
		submit: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return _authManager.AuthManager.sharedInstance.logIn(formData);
	
							case 3:
	
								if (formData.redirect) {
									// Note for future, navigateTo will only navigate to URLs on the site,
									// so it's not a security risk that will allow random other sites on the
									// login page redirect.
									(0, _link.navigateTo)(formData.redirect);
								} else {
									(0, _link.navigateTo)('/my-account');
								}
								_context.next = 18;
								break;
	
							case 6:
								_context.prev = 6;
								_context.t0 = _context['catch'](0);
	
								if (!_context.t0.networkError) {
									_context.next = 12;
									break;
								}
	
								throw "Can't connect to Inside Out. Please check your network connection and try again.";
	
							case 12:
								if (!_context.t0.graphQLErrors) {
									_context.next = 16;
									break;
								}
	
								throw 'Invalid username or password. Please try again.';
	
							case 16:
								console.log('Log in error: ', _context.t0);
								throw 'Unknown error. Please try again later.';
	
							case 18:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, undefined, [[0, 6]]);
			}));
	
			return function submit(_x) {
				return _ref3.apply(this, arguments);
			};
		}()
	})(function (_ref4) {
		var form = _ref4.form;
		return _react2.default.createElement(
			form.Form,
			null,
			_react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ 'aria-live': 'assertive' },
					form.submitError && _react2.default.createElement(
						'p',
						{ className: _globalStyles.formSection.validationMessage },
						'Error: ',
						form.submitError
					),
					form.hasErrors && _react2.default.createElement(
						'ul',
						{ className: _globalStyles.formSection.validationSummary },
						Object.keys(form.errors).map(function (key) {
							return _react2.default.createElement(
								'li',
								{ key: key, className: _globalStyles.formSection.validationMessage },
								'' + form.errors[key]
							);
						})
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _globalStyles.formSection.field },
					form.errors['email'] && _react2.default.createElement(
						'p',
						{ className: _globalStyles.formSection.validationFieldMessage },
						form.errors['email']
					),
					_react2.default.createElement(
						'label',
						{ htmlFor: 'emailAddress' },
						'Email Address'
					),
					_react2.default.createElement('input', _extends({ id: 'emailAddress' }, form.getInputProps({ name: 'email', type: 'text' })))
				),
				_react2.default.createElement(
					'div',
					{ className: _globalStyles.formSection.field },
					form.errors['password'] && _react2.default.createElement(
						'p',
						{ className: _globalStyles.formSection.validationFieldMessage },
						form.errors['password']
					),
					_react2.default.createElement(
						'label',
						{ htmlFor: 'password' },
						'Password'
					),
					_react2.default.createElement(_reactPasswordMask2.default, _extends({
						useVendorStyles: false,
						id: 'password'
					}, form.getInputProps({ name: 'password', type: 'password' })))
				),
				_react2.default.createElement(
					'div',
					{ className: _logIn.formBottomStyle },
					_react2.default.createElement(
						'div',
						{ className: _logIn.checkboxWrapStyle },
						_react2.default.createElement(
							'label',
							null,
							_react2.default.createElement('input', _extends({
								className: _globalStyles.formSection.checkbox,
								id: 'rememberMe'
							}, form.getInputProps({ name: 'rememberMe', type: 'checkbox' }))),
							_react2.default.createElement(
								'span',
								null,
								'Remember me'
							)
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_link.Link,
							{ to: '/forgot-password' },
							'Forgot password?'
						)
					)
				),
				_react2.default.createElement(
					'button',
					{
						className: _globalStyles.formSection.submitButton,
						type: 'submit',
						disabled: form.hasErrors || form.isLoading
					},
					'Log in'
				)
			)
		);
	});
	
	var LoginPage = function (_React$PureComponent) {
		_inherits(LoginPage, _React$PureComponent);
	
		function LoginPage() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, LoginPage);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.componentDidMount = function () {
				var location = _this.props.location;
	
	
				_headerManager.HeaderManager.headerProperties = {
					cta: {
						question: 'No account?',
						callToAction: {
							to: '/register' + location.search,
							name: 'Register'
						}
					}
				};
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		LoginPage.prototype.render = function render() {
			var location = this.props.location;
	
			var query = _qs2.default.parse(location.search, { ignoreQueryPrefix: true });
	
			return _react2.default.createElement(
				'div',
				{ className: _logIn.wrapperStyle },
				_react2.default.createElement(_reactHelmet.Helmet, { title: 'Login' }),
				_react2.default.createElement(
					'section',
					{ className: _logIn.innerWrapperStyle },
					_react2.default.createElement(
						'h1',
						{ className: _logIn.titleStyle },
						'Welcome back!'
					),
					_react2.default.createElement(
						'h3',
						null,
						'Trying to log in to an eLearning course?'
					),
					_react2.default.createElement(
						'p',
						null,
						'Head over to ',
						_react2.default.createElement(
							'a',
							{ href: '//insideoutinstitute.litmos.com/account/Login' },
							'here'
						)
					),
					_react2.default.createElement(
						'strong',
						null,
						'Attention: logins are currently disabled. We are working to resolve this issue'
					),
					_react2.default.createElement(LoginForm, { redirect: query.redirect })
				)
			);
		};
	
		return LoginPage;
	}(_react2.default.PureComponent);
	
	LoginPage.propTypes = {
		location: _propTypes2.default.shape({
			search: _propTypes2.default.string
		})
	};
	exports.default = LoginPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-log-in-index-js-f3b1c93a9f8c3e245aad.js